<template>
  <div
    class="networkInfo q-body-2"
    :style="syncBarColor"
    v-if="!!syncMessage"
    @click="$router.push({ name: 'taskList' })"
  >
    <div class="row no-wrap justify-center">
      <q-icon name="cached" size="20px" />
      <div class="q-mr-xs">{{ syncMessage }}.</div>
      <div class="text-weight-bold">{{ $t('sync.show') }}</div>
      .
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isOnline: false,
      offlinePendingChangesCount: 0,
      intervalListener: null
    }
  },
  computed: {
    ...mapGetters({
      pendingChangesCount: 'common/pendingChangesCount'
    }),
    syncMessage() {
      let message = ''
      if (this.pendingChangesCount > 0) {
        let taskStatus = this.isOnline
          ? this.$t('sync.pending')
          : this.$t('sync.waiting')
        message = `${this.pendingChangesCount} ${this.$t('sync.elementToSend', {
          taskStatus
        })}`
      }
      if (!this.isOnline && this.offlinePendingChangesCount > 0) {
        message = `${this.offlinePendingChangesCount} ${this.$t(
          'sync.elementPending'
        )}`
      }
      return message
    },
    syncBarColor() {
      return {
        '--notif-bg-color': this.isOnline ? '#FC4' : '#db2828'
      }
    }
  },
  watch: {
    async isOnline(val) {
      if (!val) {
        if (this.intervalListener) {
          clearInterval(this.intervalListener)
        }
        this.offlinePendingChangesCount = await this.$DB.getItemsToSync()
        this.intervalListener = setInterval(async () => {
          this.offlinePendingChangesCount = await this.$DB.getItemsToSync()
        }, 5000)
      } else {
        if (this.intervalListener) {
          clearInterval(this.intervalListener)
        }
      }
    }
  },
  methods: {
    handleOnlineEvent() {
      this.isOnline = true
    },
    handleOfflineEvent() {
      this.isOnline = false
    }
  },
  async created() {
    const { Network } = await import('Capacitor/@capacitor/network')
    if (this.$q.platform.is.capacitor) {
      this.isOnline = (await Network.getStatus()).connected
      Network.addListener('networkStatusChange', (status) => {
        this.isOnline = status.connected
      })
    } else {
      this.isOnline = navigator.onLine
      window.addEventListener('offline', this.handleOfflineEvent)
      window.addEventListener('online', this.handleOnlineEvent)
    }

    if (!this.isOnline) {
      this.offlinePendingChangesCount = await this.$DB.getItemsToSync()
    }
  },
  beforeUnmount() {
    window.removeEventListener('offline', this.handleOfflineEvent)
    window.removeEventListener('online', this.handleOnlineEvent)
    if (this.intervalListener) {
      clearInterval(this.intervalListener)
    }
  }
}
</script>

<style lang="stylus" scoped>
.networkInfo {
  padding: 2px
  text-align: center
  background-color: var(--notif-bg-color)
  color: white
}

.text-weight-bold {
  text-decoration: underline
}
</style>
